import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

const GridFader = withStyles(theme => ({
  root: {
    display: 'grid',
    overflow: 'hidden',
    '& > div': {
      display: 'grid',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'auto',
      [theme.breakpoints.down('md')]: {
        '& *::-webkit-scrollbar': {
          width: '0px',
        },
      },
    },
  },
}))(Box);

export default GridFader;
